<template>
  <div class="categoliesBg">
    <!-- 导航栏 -->
    <Header :title="$t('T_SEARCH_CATEGORY')" link="home"></Header>
    <!-- 选择框 -->
    <div class="appContent">
      <div class="ellipse-border clearfix categolies-toggle">
        <div
          class="toggle-ellipse-box"
          :class="{ 'checked-ellipse-box ellipse-border-noShadow': cateRadio == 'bmRadio', 'unchecked-ellipse-box': cateRadio != 'bmRadio' }"
          @click="changeChecked('bmRadio')"
        >
          <span>{{$t('T_BUSINESS_MODEL')}}</span>
        </div>
        <div
          class="toggle-ellipse-box"
          :class="{ 'checked-ellipse-box ellipse-border-noShadow': cateRadio == 'htmRadio', 'unchecked-ellipse-box': cateRadio != 'htmRadio', 'htmDisable': htWorkFlag}"
          @click="changeChecked('htmRadio')"
        >
          <span>{{$t('T_HOME_MODEL')}}</span>
        </div>
      </div>
      <!-- 选择框 -->
      <div class="categolies">
        <div v-if="cateRadio === 'bmRadio'">
          <dropdown :title="$t('T_CATEGORY')" :disabled="false" :label="'label'" v-model="cateValue" :selectData="businessModelOptions" @change="onBusinessCateChange" ></dropdown>
          <dropdown :title="$t('T_MODEL')" :disabled="!bmMatchingModelData.length" :label="'name'" :valuekey="'name'" v-model="bmSelectedModel" :selectData="bmMatchingModelData" @change="onBmModelChange"></dropdown>
          <dropdown :title="$t('T_OPTION_LENS')" :disabled="bmMatchingLensID && bmMatchingLensID.length ? false : true" :label="'name'" :valuekey="'id'" v-model="bmSelectedLens" :selectData="bmMatchingLensID" @change="onBmLensChange"></dropdown>
        </div>
        <div v-else>
          <dropdown v-if="isConfigured" v-model="htmCateValue" :label="'label'" :selectData="homeModelOptions" @change="onHomeCateChange"></dropdown>
          <dropdown v-else :title="$t('T_CATEGORY')" :disabled="true" :label="'label'" v-model="disableValue" :selectData="[disableValue]"></dropdown>
          <dropdown :title="$t('T_MODEL')" :disabled="false" :label="'name'" :valuekey="'name'" v-model="htmSelectedModel"  :selectData="htmMatchingModelData" @change="onHtmModelChange"></dropdown>
          <dropdown :title="$t('T_OPTION_LENS')" :disabled="true" :label="'name'" v-model="disableValue" :selectData="[disableValue]"></dropdown>
        </div>
      </div>
      <div class="btn-box">
        <van-button round type="info" size="large" @click="goProject">OK</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import dropdown from '@/components/Dropdown'
import Header from '@/components/header'
// import ProjectorSpec from '@/assets/data/projectorSpec.json'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'catogolies',
  data () {
    return {
      businessModelOptions: [
        {
          value: 0,
          label: this.$t('T_CATEGORY_SELECT_1'),
          globalKey: 'T_CATEGORY_SELECT_1'
        },
        {
          value: 1,
          label: this.$t('T_CATEGORY_SELECT_2'),
          globalKey: 'T_CATEGORY_SELECT_2'
        },
        {
          value: 2,
          label: this.$t('T_CATEGORY_SELECT_3'),
          globalKey: 'T_CATEGORY_SELECT_3'

        },
        {
          value: 3,
          label: this.$t('T_CATEGORY_SELECT_4'),
          globalKey: 'T_CATEGORY_SELECT_4'
        },
        {
          value: 4,
          label: this.$t('T_CATEGORY_SELECT_5'),
          globalKey: 'T_CATEGORY_SELECT_5'
        }
      ],
      homeModelOptions: [],
      selectData: [],
      bmSelectedModel: '',
      bmSelectedLens: '',
      htmSelectedModel: '',
      disableValue: '- - -',
      htmCateValue: 6,
      htWorkFlag: false,
      configuredItem: {},
      initModelName: this.$store.state.selectedModelData.name,
      initCode: this.$store.state.selectedModelData.code,
      modelChangeFlag: false
    }
  },
  computed: {
    ...mapState(['selectedModelData', 'matchingModelData',
      'bmMatchingModelData', 'bmSelectedModelData', 'bmMatchingLensID', 'bmSelectedLensData',
      'htmMatchingModelData', 'htmSelectedModelData', 'htmSelectedLensData',
      'cateRadio', 'cateValue', 'isConfigured'
    ]),
    cateRadio: {
      get () {
        return this.$store.state.cateRadio
      },
      set (val) {
        this.CATERADIO(val)
      }
    },
    cateValue: {
      get () {
        return this.$store.state.cateValue
      },
      set (val) {
        this.CATEVALUE(val)
      }
    },
    bmMatchingModelDataSort () {
      return this.$commonJs.dataSort(this.bmMatchingModelData, 'name')
    },

    htmMatchingModelDataSort () {
      return this.$commonJs.dataSort(this.htmMatchingModelData, 'name')
    },

    bmMatchingLensIDSort () {
      return this.$commonJs.dataSort(this.bmMatchingLensID, 'name')
    }
  },
  watch: {
    cateRadio (val) {
      this.CATERADIO(val)
      this.upDateData()
    },
    searchTabActiveName (val) {
      if (val === 'Categolies') {
        this.upDateData()
      }
    },
    bmSelectedModelData (value) {
      this.bmSelectedModel = value ? value.name : this.disableValue
    },
    htmSelectedModelData (value) {
      this.htmSelectedModel = value ? value.name : this.disableValue
    },
    bmSelectedLensData (value) {
      if (value) {
        this.bmSelectedLens = value.id ? value.id : this.disableValue
      }
    }
  },
  methods: {
    onClickLeft () {
      this.$router.push({ path: '/' })
    },

    changeChecked (val) {
      let index
      if (val === 'htmRadio' && this.htWorkFlag) {
        return
      }
      if (val === 'bmRadio') {
        index = 0
      } else {
        index = 1
      }

      if (index === 0) {
        this.CATERADIO('bmRadio')
      } else {
        this.CATERADIO('htmRadio')
      }
      this.upDateData()
      this.CATEVALUE(index)
    },

    clickSelect () {
      this.$refs.select1.onclick()
    },

    goProject () {
      this.SEARCHTABACTIVENAME(this.cateRadio)
      this.$router.push({ name: 'projectorInfo', params: { modelChange: this.modelChangeFlag } })
    },
    ...mapMutations([
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA',
      'BMMATCHINGMODELDATA', 'BMSELECTEDMODELDATA', 'BMMATCHINGLENSID', 'BMSELECTEDLENSDATA',
      'HTMMATCHINGMODELDATA', 'HTMSELECTEDMODELDATA', 'HTMSELECTEDLENSDATA',
      'CATERADIO', 'CATEVALUE', 'SEARCHTABACTIVENAME'
    ]),
    upDateData () {
      if (this.cateRadio === 'bmRadio') {
        this.MATCHINGMODELDATA(this.bmMatchingModelData)
        this.SELECTEDMODELDATA(this.bmSelectedModelData)
        this.MATCHINGLENSID(this.bmMatchingLensID)
        this.SELECTEDLENSDATA(this.bmSelectedLensData)
      } else {
        this.MATCHINGMODELDATA(this.htmMatchingModelData)
        this.SELECTEDMODELDATA(this.htmSelectedModelData)
        this.MATCHINGLENSID()
        this.SELECTEDLENSDATA(this.htmSelectedLensData)
      }
      this.modelChangeFlag = this.initModelName !== this.$store.state.selectedModelData.name || this.initCode !== this.$store.state.selectedModelData.code
    },
    onBmModelChange (value, code) {
      this.modelChangeFlag = this.initModelName !== value || this.initCode !== code
      let bmSelectedModelData = this.bmMatchingModelData.find(item => item.name === value && item.code === code)
      this.SELECTEDMODELDATA(bmSelectedModelData)
      this.BMSELECTEDMODELDATA(bmSelectedModelData)
      let bmLensData = this.findMatchingLensAndSelectedLensData(bmSelectedModelData)
      this.BMMATCHINGLENSID(bmLensData.matchingLensID)
      this.BMSELECTEDLENSDATA(bmLensData.selectedLensInfo)
      this.MATCHINGLENSID(bmLensData.matchingLensID)
      this.SELECTEDLENSDATA(bmLensData.selectedLensInfo)
    },
    onHtmModelChange (value, code) {
      this.modelChangeFlag = this.initModelName !== value || this.initCode !== code
      let htmSelectedModelData = this.htmMatchingModelData.find(item => item.name === value && item.code === code)
      this.SELECTEDMODELDATA(htmSelectedModelData)
      this.HTMSELECTEDMODELDATA(htmSelectedModelData)
      let htmLensData = this.findMatchingLensAndSelectedLensData(htmSelectedModelData)
      this.HTMSELECTEDLENSDATA(htmLensData.selectedLensInfo)
      this.SELECTEDLENSDATA(htmLensData.selectedLensInfo)
    },
    findMatchingLensAndSelectedLensData (model) {
      return this.$commonJs.findLensInfo(model)
    },
    onBusinessCateChange (val) {
      let matchingModel = null

      if (this.isConfigured) {
        matchingModel = this.$commonJs.findMatchingModelByConf(val)
      } else {
        switch (val) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            matchingModel = this.$commonJs.findMatchingModel(val)
            break
          default:
            matchingModel = this.ProjectorSpec
        }
      }
      if (matchingModel.length === 0) {
        this.bmSelectedModel = this.disableValue
        this.BMMATCHINGMODELDATA('')
        return
      }
      let bmMatchingModelData = matchingModel
      let bmSelectedModelData = matchingModel[0]
      this.bmSelectedModel = bmSelectedModelData ? bmSelectedModelData.name : this.disableValue
      this.SELECTEDMODELDATA(bmSelectedModelData)
      this.MATCHINGMODELDATA(bmMatchingModelData)

      this.BMMATCHINGMODELDATA(bmMatchingModelData)
      this.BMSELECTEDMODELDATA(bmSelectedModelData)
      let bmLensData = this.findMatchingLensAndSelectedLensData(bmSelectedModelData)
      this.BMMATCHINGLENSID(bmLensData.matchingLensID)
      this.BMSELECTEDLENSDATA(bmLensData.selectedLensInfo)

      this.MATCHINGLENSID(bmLensData.matchingLensID)
      this.SELECTEDLENSDATA(bmLensData.selectedLensInfo)
      this.modelChangeFlag = this.initModelName !== this.$store.state.selectedModelData.name || this.initCode !== this.$store.state.selectedModelData.code
    },
    onBmLensChange (value) {
      let data = this.$commonJs.findLensDataByIdAndSize(value, this.selectedModelData.lcdSize)
      this.SELECTEDLENSDATA(data)
      this.BMSELECTEDLENSDATA(data)
    },
    initBmValue () {
      let bmMatchingModelData
      if (this.isConfigured) {
        for (let i = 0; i < 6; i++) {
          bmMatchingModelData = this.$commonJs.findMatchingModelByConf(i)
          if (bmMatchingModelData !== undefined && bmMatchingModelData.length !== 0) {
            this.CATEVALUE(i)
            break
          }
        }
      } else {
        bmMatchingModelData = this.$commonJs.findMatchingModel(0)
      }
      let bmSelectedModelData = bmMatchingModelData[0]
      this.bmSelectedModel = bmSelectedModelData.name || this.disableValue
      let bmLensData = this.findMatchingLensAndSelectedLensData(bmSelectedModelData)
      this.BMMATCHINGMODELDATA(bmMatchingModelData)
      this.BMSELECTEDMODELDATA(bmSelectedModelData)
      this.BMMATCHINGLENSID(bmLensData.matchingLensID)
      this.BMSELECTEDLENSDATA(bmLensData.selectedLensInfo)
      this.initCateGory()
    },
    initCateGory () {
      // businessModelOptions
      if (this.isConfigured) {
        let c5 = this.ProjectorSpec.filter(item => {
          return item.c5 && item.c5 === true
        })
        let v = this.configuredItem.categoliesBm.split(',')
        if (c5.length === 0) v = v.splice(0, v.length - 1)
        let cas = []
        for (let i = 0; i < v.length; i++) {
          let ca = {}
          switch (v[i]) {
            case 'Standard / Classroom / Mobile model':
              ca.label = this.$t('T_CATEGORY_SELECT_1')
              ca.globalKey = 'T_CATEGORY_SELECT_1'
              break
            case 'Short Throw / Ultra Short Throw model':
              ca.label = this.$t('T_CATEGORY_SELECT_2')
              ca.globalKey = 'T_CATEGORY_SELECT_2'
              break
            case 'Signage / Lighting model':
              ca.label = this.$t('T_CATEGORY_SELECT_3')
              ca.globalKey = 'T_CATEGORY_SELECT_3'
              break
            case 'High Brightness model(Lens fixed)':
              ca.label = this.$t('T_CATEGORY_SELECT_4')
              ca.globalKey = 'T_CATEGORY_SELECT_4'
              break
            case 'High Brightness model(with optional lenses)':
              ca.label = this.$t('T_CATEGORY_SELECT_5')
              ca.globalKey = 'T_CATEGORY_SELECT_5'
              break
            default:
              ca.label = v[i]
              ca.globalKey = v[i]
          }
          ca.value = i
          if (v[i]) {
            cas.push(ca)
          }
        }
        this.businessModelOptions = cas
        let hv = this.configuredItem.categoliesHtm.split(',')
        let c7 = this.ProjectorSpec.filter(item => {
          return item.c7 && item.c7 === true
        })
        let c8 = this.ProjectorSpec.filter(item => {
          return item.c8 && item.c8 === true
        })
        if (c7.length === 0) hv[1] = ''
        if (c8.length === 0) hv[2] = ''
        let hcas = []
        for (let i = 0; i < hv.length; i++) {
          if (!hv[i]) continue
          let ca = {}
          ca.label = hv[i]
          ca.value = i + 6
          if (hv[i]) {
            hcas.push(ca)
          }
        }
        this.homeModelOptions = hcas
      }
    },
    onHomeCateChange (val) {
      let htmMatchingModelOptions = this.$commonJs.findMatchingModelByConf(val)
      if (htmMatchingModelOptions.length === 0) {
        this.htmSelectedModel = this.disableValue
        this.HTMMATCHINGMODELDATA('')
        return
      }
      let htmSelectedModelData = htmMatchingModelOptions[0]
      if (htmSelectedModelData) {
        this.htmSelectedModel = htmSelectedModelData.name
        let htmLensData = this.findMatchingLensAndSelectedLensData(htmSelectedModelData)
        this.HTMMATCHINGMODELDATA(htmMatchingModelOptions)
        this.HTMSELECTEDMODELDATA(htmSelectedModelData)
        this.HTMSELECTEDLENSDATA(htmLensData.selectedLensInfo)
        this.onHtmModelChange(htmSelectedModelData.name)
      }
    },
    initHtmValue () {
      let htmMatchingModelOptions
      if (this.isConfigured) {
        htmMatchingModelOptions = this.$commonJs.findMatchingModelByConf(6)
        let htmMatchingModelOption7 = this.$commonJs.findMatchingModelByConf(7)
        let htmMatchingModelOption8 = this.$commonJs.findMatchingModelByConf(8)
        if (htmMatchingModelOptions.length === 0 && htmMatchingModelOption7.length === 0 && htmMatchingModelOption8.length === 0) {
          this.htWorkFlag = true
        }
      } else {
        htmMatchingModelOptions = this.$commonJs.findMatchingModel(5)
      }
      let htmSelectedModelData = htmMatchingModelOptions[0]
      if (htmSelectedModelData) {
        this.htmSelectedModel = htmSelectedModelData.name
        let htmLensData = this.findMatchingLensAndSelectedLensData(htmSelectedModelData)
        this.HTMMATCHINGMODELDATA(htmMatchingModelOptions)
        this.HTMSELECTEDMODELDATA(htmSelectedModelData)
        this.HTMSELECTEDLENSDATA(htmLensData.selectedLensInfo)
      }
    },
    onBrowserBack () {
      let hash = window.location.hash
      if (hash === '#/categolies') {
        this.$router.push({ path: '/' })
      }
    }
  },
  created () {
    if (this.isConfigured) {
      this.configuredItem = this.ProjectorSpec.filter(item => {
        return item.isMainPSConfig === 1
      })[0]
    }
    this.initBmValue()
    this.initHtmValue()
    this.upDateData()
  },
  mounted () {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.onBrowserBack, false)
    }
  },
  destroyed () {
    if (window.history && window.history.pushState) {
      window.removeEventListener('popstate', this.onBrowserBack, false)
    }
  },
  components: {
    dropdown,
    Header
  }
}
</script>

<style scoped>
  .categolies{
    padding-top: 5px;
  }
  .appContent{
    padding-top:5px
  }
  .htmDisable{
    background: #C0C4CC
  }
</style>
